import {HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable, OnDestroy} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {NavigationStart, Router} from "@angular/router";
import {filter} from "rxjs/operators/filter";
import {takeUntil} from "rxjs/operators/takeUntil";
import {Subject} from "rxjs";

@Injectable()
export class CacheInterceptor implements HttpInterceptor, OnDestroy {
	private cache: Map<string, Observable<any> | HttpResponse<any>> = new Map();

	private destroy$: Subject<boolean> = new Subject<boolean>();

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.unsubscribe();
	}

	constructor(router: Router) {
		router.events
			.pipe(takeUntil(this.destroy$),
				filter(event => event instanceof NavigationStart))
			.subscribe(() => this.cache = new Map());
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.method !== "GET") {
			return next.handle(req)
		}
		const url = req.urlWithParams;
		if(url.toLowerCase().indexOf('medeservice') !== -1 || url.indexOf('KPI') !== -1){
			return next.handle(req);
		}
		if(url.toLowerCase().indexOf('jobmanage') !== -1){
			return next.handle(req);
		}
		if(url.toLowerCase().indexOf('lockservice') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('GCEvaluation') !== -1 || url.indexOf('KPI') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('deservice') !== -1 && url.indexOf('action') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('deservice') !== -1 && url.indexOf('Budget/instance') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('deservice') !== -1 && url.indexOf('Proposal/instance') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('deservice') !== -1 && url.indexOf('GrantExpenditure/instance') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('Farmer') !== -1 && url.indexOf('entity') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('Farmer') !== -1 && url.indexOf('entities') !== -1){
			return next.handle(req);
		}
		if (url.indexOf('/implementation-frameworks/Grant/') !== -1 && (url.indexOf('/result-frameworks/1/items') !== -1
			|| url.indexOf('/result-frameworks/48/items') !== -1 || url.indexOf('/result-frameworks/49/items') !== -1)){
			return next.handle(req);
		}
		if(url.indexOf('classifierservice') && (url.indexOf('BudgetLineItem') !== -1 || url.indexOf('Contact') !== -1
			|| url.indexOf('GRFLevel1') !== -1 || url.indexOf('GRFLevel2') !== -1 || url.indexOf('GRFLevel3') !== -1
			|| url.indexOf('GRFLevel4') !== -1 || url.indexOf('GRFLevel5') !== -1 || url.indexOf('KPI') !== -1
			|| url.indexOf('Activity') !== -1 || url.indexOf('Milestone') !== -1 || url.indexOf('Factor') !== -1)){
			return next.handle(req);
		}
		if(url.indexOf('auditservice') !== -1 || url.indexOf('permission') !== -1){
			return next.handle(req);
		}
		if(url.indexOf('entitysearchservice') !== -1 && url.indexOf('Budget') !== -1){
			return next.handle(req);
		}
		if (url.indexOf('entitysearchservice') !== -1 && url.indexOf('Indicator') !== -1) {
			return next.handle(req);
		}
		if (url.indexOf('groups') !== -1 || url.indexOf('comments') !== -1) {
			return next.handle(req);
		}
		const cachedResponse: Observable<any> | HttpResponse<any> = this.cache.get(url);
		if (cachedResponse) {
			return (cachedResponse instanceof Observable) ? cachedResponse : Observable.of(cachedResponse.clone());
		}
		const obs$ = next.handle(req).do((stateEvent: any) => {
			stateEvent instanceof HttpResponse && this.cache.set(url, stateEvent.clone());
			return stateEvent;
		}).share();
		this.cache.set(url, obs$);
		return obs$;
		// return Observable.of(cachedResponse.clone());
	}
}
